import { RecordType } from 'app/constants/GlobalTypes'

import BaseReducer from './Base'

const ContactOrganization = BaseReducer<IContactOrganization>({
  recordType: RecordType.contact_organization
})

export default ContactOrganization
